import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { store } from './redux/store';
import { fetchPupCatalog } from './redux/pupCatalogSlice';

// Bring the realtime socket up on boot if we're already authenticated (page refresh or a
// deep-link into a protected route). Without this the socket only opens on an explicit login,
// so a reload leaves an authenticated user with a dead socket and a frozen table. The
// middleware no-ops if the persisted token is missing/expired.
store.dispatch({ type: 'auth/connectSocket' });

// Fetch the Power-Up card catalog (public endpoint — no auth needed) so card codes arriving
// over the socket resolve to display data. Unconditional: cheap, and the slice serves a
// localStorage-cached copy instantly while this revalidates the version in the background.
store.dispatch(fetchPupCatalog());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Provider store={store}><App /></Provider>);
